export const OPTIONS_DROPDOWN_FILTER_NOTIFICATION = {
  'Report Type': 'reportType',
  'Client Name': 'clientName',
};
